import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';

const img3 = 'https://dt7j04u1665qi.cloudfront.net/DOHA_QATAR_MARCH_29_and_30_b99edc58e2.webp'
const img4 = 'https://dt7j04u1665qi.cloudfront.net/Feb_Brussels_f1c6b2b176.webp'
const img5 = 'https://dt7j04u1665qi.cloudfront.net/Feb_doha_b9bd7690ef.webp'
const img6 = 'https://dt7j04u1665qi.cloudfront.net/Feb_Dubai_76030ba370.webp'
const img7 = 'https://dt7j04u1665qi.cloudfront.net/Feb_paris_944a7b0bda.webp'
const img8 = 'https://dt7j04u1665qi.cloudfront.net/Feb_Riyadh_2273ce14c3.webp'
const img9 = 'https://dt7j04u1665qi.cloudfront.net/Feb_Shanghai_d26845f356.webp'
const img10 = 'https://dt7j04u1665qi.cloudfront.net/Jan_Bucharest_8b8731529f.webp'
const img11 = 'https://dt7j04u1665qi.cloudfront.net/Jan_Riyadh_40edce2951.webp'
const img12 = 'https://dt7j04u1665qi.cloudfront.net/Jan_tokyo_5f3ce45375.webp'
const img13 = 'https://dt7j04u1665qi.cloudfront.net/march_21_and_22_2024_82179e5052.webp'

function RoadShow() {
    const missionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.3 }
        );

        if (missionRef.current) {
            observer.observe(missionRef.current);
        }
    }, [missionRef]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]
    };

    const props = [
        { id: 3, place: 'Toronto', date: '14-15 November 2026', imgUrl: img3 },
        { id: 4, place: 'Sydney', date: '21-22 November 2026', imgUrl: img4 },
        { id: 5, place: 'Brussels', date: '28-29 November 2026', imgUrl: img5 },
        { id: 6, place: 'Tokyo', date: '5-6 December 2026', imgUrl: img6 },
        { id: 7, place: 'Paris', date: '12-13 December 2026', imgUrl: img7 },
        { id: 8, place: 'Riyadh', date: '9-10 January 2027', imgUrl: img8 },
        { id: 9, place: 'Doha', date: '16-17 January 2027', imgUrl: img9 },
        { id: 10, place: 'Dubai', date: '23-24 January 2027', imgUrl: img10 },
        { id: 11, place: 'Shanghai', date: '6-7 February 2027', imgUrl: img11 },
        { id: 12, place: 'Paris', date: '20-21 February 2027', imgUrl: img12 },
        { id: 13, place: 'Brussels', date: '13-14 March 2027', imgUrl: img13 },
    ];

    const Card = ({ imgUrl, place, date }) => (
        <div className={`px-2 py-2 ${isVisible ? 'animate-slideInTop opacity-100' : 'opacity-0'}`}>
            <div className="bg-white/5 rounded-lg overflow-hidden shadow-md cursor-pointer transition-transform duration-250 ease-in-out hover:transform hover:-translate-y-1 hover:shadow-lg border border-white/10">
                <div className="h-44 sm:h-52 md:h-60 w-full overflow-hidden bg-gray-900">
                    <img
                        src={imgUrl}
                        loading="lazy"
                        alt={place}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="p-4">
                    <h2 className="text-base sm:text-lg font-bold text-white tracking-wider">{place}</h2>
                    <p className="text-xs sm:text-sm text-gray-400 mt-1">{date}</p>
                </div>
            </div>
        </div>
    );

    return (
        <div ref={missionRef} className="w-full overflow-hidden">
            <Slider {...settings}>
                {props.map((card) => (
                    <Card
                        key={card.id}
                        place={card.place}
                        date={card.date}
                        imgUrl={card.imgUrl}
                    />
                ))}
            </Slider>
        </div>
    );
}

export default RoadShow;
